import { Injectable } from '@angular/core';
import { SalesEngineService } from '../api/sales-engine.service';
import { IndicatorGet, IndicatorVariableGet, LogicFunction, LogicOperation, OpportunityGet, ProductGet, SignalGet } from '../interfaces/sales-engine-interfaces';

@Injectable({
  providedIn: 'root'
})
export class SalesEngineDataService {
  constructor(private salesEngineService: SalesEngineService) {
    this.reloadSystemVariables();
    this.reloadIndicators();
    this.reloadSignals();
    this.reloadProducts();
    this.reloadOpportunities();
  }

  // Variables
  systemVariables: IndicatorVariableGet[] = [];

  loadSystemVariables() {
    this.salesEngineService.getIndicatorVariables().subscribe({
      next: (response) => {
        if (response) {
          this.systemVariables = [...response];
        }
      },
      error: async (error) => {
      },
      complete: () => {
      }
    });
  }

  reloadSystemVariables = () => {
    this.systemVariables = [];
    this.loadSystemVariables();
  }

  getSystemVariables(): IndicatorVariableGet[] {
    return this.systemVariables;
  }

  // Indicators
  indicators: IndicatorGet[] = [];

  loadIndicators() {
    this.salesEngineService.getIndicators().subscribe({
      next: (response) => {
        if (response) {
          this.indicators = [...response];
        }
      },
      error: async (error) => {
      },
      complete: () => {
      }
    });
  }

  reloadIndicators = () => {
    this.indicators = [];
    this.loadIndicators();
  }

  getIndicators(): IndicatorGet[] {
    return this.indicators;
  }

  // Signals
  signals: SignalGet[] = [];

  loadSignals() {
    this.salesEngineService.getSignals().subscribe({
      next: (response) => {
        if (response) {
          this.signals = [...response];
        }
      },
      error: async (error) => {
      },
      complete: () => {
      }
    });
  }

  reloadSignals = () => {
    this.signals = [];
    this.loadSignals();
  }

  getSignals(): SignalGet[] {
    return this.signals;
  }

  // Products
  products: ProductGet[] = [];

  loadProducts() {
    this.salesEngineService.getProducts().subscribe({
      next: (response) => {
        if (response) {
          this.products = [...response];
        }
      },
      error: async (error) => {
      },
      complete: () => {
      }
    });
  }

  reloadProducts = () => {
    this.products = [];
    this.loadProducts();
  }

  getProducts(): ProductGet[] {
    return this.products;
  }

  // Opportunities
  opportunities: OpportunityGet[] = [];

  loadOpportunities() {
    this.salesEngineService.getOpportunities().subscribe({
      next: (response) => {
        if (response) {
          this.opportunities = [...response];
        }
      },
      error: async (error) => {
      },
      complete: () => {
      }
    });
  }

  reloadOpportunities = () => {
    this.opportunities = [];
    this.loadOpportunities();
  }

  getOpportunities(): OpportunityGet[] {
    return this.opportunities;
  }
}
